import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { useQuery } from '@tanstack/react-query';

export const useGetAdvancedAnalysis = ({ assetId }: { assetId?: string }) => {
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();
  const { data, isFetching, error, refetch } = useQuery({
    queryKey: ['assets.getAdvancedAnalysis', { assetId, tenantId }],
    queryFn: () => api.assets.getAdvancedAnalysis(assetId ?? '', tenantId),
    enabled: !!assetId && !!tenantId,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });

  return {
    analysis: data?.data.analysis,
    isFetching,
    error,
    refetch,
  };
};
